import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import { LinearProgress, Tab, Tabs } from '@material-ui/core'
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ReduxCallHelper from "../../../../store/actionreducers/callHelper";
import {FusePageSimple} from '../../../../@fuse/index';
import ContactsList from './MedicalList';
import MedicalDialog from './MedicalDialog';
import UecareListHeader from "../../../../components/header/UecareListHeader";
import {FuseAnimate} from "../../../../@fuse";
import {UecareFAB} from "../../../../components";
import {constDataDialogs} from "../../../../constants";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxCity from "../../../../store/actionreducers/city";
import UecareAlertDialog from "../../../../components/UecareAlertDialog";


const tabValueToRoleIdMapping = {
    0: 6,
    1: 7,
    2: 8,
    3: 9,
    4: 10,
    5: 12,
    6: 1,
    7: 4,
};

class MedicalsApp extends Component {


    state = {
        tabValue: 0,
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({tabValue});
    };

    async componentDidMount() {
        await this._reload()
        try {
            await this.props.getMedicals();
            await this.props.getCities();
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    async _reload() {
        this.setState({ isLoading: true })
        await this.props.getCities()
        await this.props.getMedicals()
        this.setState({ isLoading: false })
    }

    render() {
        const {classes, openDataDialog, medicals, user} = this.props;
        const {tabValue} = this.state;

        const filteredMedicals = medicals
                                    .filter((medical) => {
                                        if (user.callCenterInstitution.length === 0) return true
                                        if (!medical.institution) return false
                                        if (!medical.institution.id) return false
                                        return (user.callCenterInstitution.indexOf(medical.institution.id) !== -1)
                                    })
                                    .filter((medical) => medical.user.fk_role_id === tabValueToRoleIdMapping[tabValue]);

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='合作夥伴列表' icon='local_hospital' reload={() => this._reload()} />
                    }
                    contentToolbar={
                        <div style={{ width: '100%' }}>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <Tabs
                                value={tabValue}
                                onChange={this.handleChangeTab}
                                indicatorColor="secondary"
                                textColor="secondary"
                                scrollable
                                scrollButtons="auto"
                                classes={{ root: 'w-full h-40' }}
                                className='bg-grey-light'>
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="急診醫師" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="專科醫師" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="顧問醫師" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="藥師" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="護理師" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="專科護理師" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="管理職醫生" />
                                <Tab className="h-40 min-w-0 normal-case font-extrabold" label="管理者" />
                            </Tabs>
                        </div>
                    }
                    content={
                        <div>
                            <div className="p-16">
                                <ContactsList medicals={filteredMedicals}/>
                            </div>
                            <UecareAlertDialog/>
                        </div>
                    }

                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />

                {
                    (true) ? '' :
                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <UecareFAB
                                icon='add'
                                onClick={() => {
                                    openDataDialog({
                                        type: constDataDialogs.type.new,
                                        name: constDataDialogs.name.medicalDialog
                                    });
                                }}/>
                        </FuseAnimate>
                }
                <MedicalDialog/>
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    layoutHeader: {
        height: 160,
    },
    layoutContentCardWrapper: {
        padding: 16,
    },
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMedicals: ReduxCallHelper.ActionCreator.getMedicals,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        getCities: ReduxCity.ActionCreator.getCities,
    }, dispatch);
}

function mapStateToProps({callHelper: {medicals}, auth}) {
    return {
        medicals, user: auth.user
    }
}
export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(MedicalsApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/medical/MedicalsApp.js